module.exports = "../../app/cells/components/related_contests_item_cell.rb";